import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path clipRule="evenodd" d="M15.788 9.465l-3.14-3.11.704-.71 4.355 4.314-4.352 4.393-.71-.704 3.153-3.183-14.797.035L1 9.5l14.789-.035z" /></svg>;